export default __webpack_public_path__ + "static/media/carteira-documentos.8628eea4.svg";